import React from "react";

import encryptionvsyou from '../../../assets/images/encryption-vs-you.png';
import bannerThub from '../../../assets/images/banner-thub-new.png';
import CTLogo from '../../../assets/images/CT-Logo.png';


function KnowledgeBanner() {
  return (
    <> 
       <div className="CT-banner">
            <img src={CTLogo} alt="CT Logo" className="CT-logo" />
            <div className="encryptionvsyou-img">encryption <span>vs</span> you</div>
            <h3><span>Get Ahead with</span> Supercharged Metadata Intelligence</h3>
        </div>     
    </>
  );
};
export default KnowledgeBanner;